import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVerticalAlignmentRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vertical-alignment-right"><path d="M20.25 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 6.75H3.75V10.25H17.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 13.75H7.75V17.25H17.25V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVerticalAlignmentRight;
